import request from '@/utils/request'

// 刷题记录

let ShuatiLogApi = {

  /*列表*/
  getList(data, errorback) {
    return request._post('/shop/study.shuati_log/index', data, errorback);
  },
}

export default ShuatiLogApi;



// WEBPACK FOOTER //
// ./src/api/study/shuati_log.js